module.exports = __webpack_public_path__ + "img/fashion_42.98180494.jpg";